module.exports = __webpack_public_path__ + "img/truck-ramp-box.3855be2e.svg";